import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import SuggestionSearchInputNew from 'components/desktop/_general/Input/SuggestionSearchInput/SuggestionSearchInputNew';
import * as SelectItem from 'types/_general/SelectItem';
import * as SelectItemList from 'types/_general/SelectItemList';

interface IProps {
	allItems: SelectItemList.Type;
	className?: string;
	disabled?: boolean;
	errorKey?: string;
	hideField?: boolean;
	label?: string;
	linkTo?: string;
	savedItem: string | null;
	setSavedItem: (savedItem: string | null) => void;
}

const SingleSearchSelectNew = (props: IProps) => {
	const { t } = useTranslation();

	const getTitle = (input: SelectItem.Type): string | undefined => {
		if (input?.source) return input.source;
		return undefined;
	};

	return (
		<div className={props.className ? `row ${props.className}` : 'row'}>
			{props.label && <label className="input-label">{props.label}</label>}
			<div className="col-12">
				{props.savedItem !== null && props.savedItem !== '' ? (
					<>
						<div
							className="d-block d-flex justify-content-between select-saveditems"
							title={getTitle(
								SelectItem.mapFromString(props.allItems, props.savedItem!)
							)}
						>
							{props.linkTo ? (
								<>
									<Link
										to={props.linkTo}
										style={{ color: 'white', textDecoration: 'none' }}
									>
										{SelectItem.mapFromString(props.allItems, props.savedItem)
											?.name ?? t('_general:BASEINGREDIENT_MISSING_NAME')}
									</Link>
								</>
							) : (
								<>
									{SelectItem.mapFromString(props.allItems, props.savedItem).name}
								</>
							)}
							<span
								onClick={() => props.setSavedItem(null)}
								style={{ display: props.hideField ? 'none' : 'block' }}
							>
								<i className="bi bi-x" />
							</span>
						</div>
					</>
				) : (
					<></>
				)}
				<div className="input-group" style={{ display: props.hideField ? 'none' : 'flex' }}>
					<SuggestionSearchInputNew
						disabled={props.disabled}
						allItems={props.allItems}
						errorKey={props.errorKey}
						savedItems={props.savedItem ? [props.savedItem] : []}
						setSavedItem={(input: string) => props.setSavedItem(input)}
					/>
				</div>
			</div>
		</div>
	);
};

export default SingleSearchSelectNew;
